import styled from "styled-components/macro";

export const InputNumberContainer = styled.div(({ theme, isValid }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  border: `1px solid ${
    isValid ? theme.color.neutral["04"] : theme.color.feedback.error
  }`,
  borderRadius: "4px",
  padding: "16px",
  width: "100%",
  /* Chrome, Safari, Edge, Opera */
  "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },

  /* Firefox */
  "input[type=number]": {
    "-moz-appearance": "textfield",
  },
  [theme.breakpoint.lg()]: {
    padding: "8px 12px",
    width: "fit-content",
  },

  "&:focus-within": {
    borderColor: theme.color.brandPrimary.light,
  },
}));

export const EmptyButton = styled.button(({ theme }) => ({
  border: "none",
  background: "none",
  cursor: "pointer",
  color: theme.color.brandPrimary.light,

  "&:disabled": {
    color: theme.color.neutral["03"],
    cursor: "not-allowed",
  },
}));

export const EmptyInput = styled.input(({ theme, isValid }) => ({
  border: "none",
  background: "none",
  textAlign: "center",
  fontSize: "16px",
  fontWeight: "500",
  color: isValid ? theme.color.neutral["02"] : theme.color.feedback.error,
  lineHeight: "150%",
  width: "fit-content",
  outline: "none",
  [theme.breakpoint.lg()]: {
    fontSize: "18px",
  },
}));

export const ErrorMessage = styled.p(({ theme }) => ({
  color: theme.color.feedback.error,
  marginBottom: 0,
}));
